module.exports = __webpack_public_path__ + "static/img/template_img_02.5517158.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img_02.jpg
// module id = 394
// module chunks = 0